import { MutationTree } from 'vuex';
import { UserMicrocertificateDTO } from '@/services/undergrad/pegasus-pepe-legal/microcertificates.service';
import { MicrocertificateState } from './state';

const mutations: MutationTree<MicrocertificateState> = {
  SET_MICROCERTIFICATES(state, microcertificates: UserMicrocertificateDTO[]) {
    state.microcertificates = microcertificates;
  },
  SET_GENERATING_MICROCERTIFICATE(state, generating: boolean) {
    state.isGenerating = generating;
  },
  SET_MICROCERTIFICATE_FILES(state, files: { pdfUrl: string; pngUrl: string }) {
    state.currentMicrocertificateFiles = files;
  },
  SET_MICROCERTIFICATE_HASH(state, hash: string) {
    state.currentMicrocertificateHash = hash;
  },
  PUSH_MICROCERTIFICATE_TO_DISPLAY(state, microcertificateId: string) {
    state.displayingMicrocertificates.push(microcertificateId);
  },
  DISMISS_MICROCERTIFICATE_FROM_DISPLAY(state, microcertificateId: string) {
    state.displayingMicrocertificates = state.displayingMicrocertificates.filter(
      (displayingMicrocertificateId) => displayingMicrocertificateId !== microcertificateId,
    );
  },
  DONE_POPUP_MICROCERTIFICATES_PUSH(state) {
    state.acceptsMicrocertificateAutoPopup = false;
  },
};

export default mutations;
